import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {debounceTime, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import { IContractCardItem } from '../contract-card-items.service';

@Component({
    selector: 'app-contract-card-column',
    templateUrl: './contract-card-column.component.html',
    styleUrls: ['./contract-card-column.component.scss']
})
export class ContractCardColumnComponent implements OnInit, OnDestroy  {
    private readonly _searchChange$: Subject<string> = new Subject<string>();
    private readonly _destroyed$ = new Subject<void>();
    private readonly _debounceTime: number = 500;

 
    search:string ='';

    @Input({required: true}) contractCardIds: number = null;
    @Input({required: true}) items: IContractCardItem[] =[];

    @Input() preselectedIds: number[] = [];
    @Output() contractCardIdsChange: EventEmitter<number[]> = new EventEmitter<number[]>();
    @Output() searchChanged: EventEmitter<string> = new EventEmitter<string>();

    onContractCardChange(ids:number[]) {
        this.contractCardIdsChange.emit(ids);
    }

    onSearchChanged(value: string) {
        this._searchChange$.next(value);
    }

    ngOnInit(): void {
        this._searchChange$
            .pipe(
                takeUntil(this._destroyed$),
                debounceTime(this._debounceTime)
            )
            .subscribe(searchValue=> this.searchChanged.next(searchValue));
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

}
